import * as React from 'react'
import { customerMarketShopfrontApi } from '@envato/foundation-types'

import { reportCategoryPageClick } from '../../../../common/analytics/categoryPageAnalytics'
import PillsNav from '../../pillsNav'
import { ICategoryPageBlockComponent } from '../../../../typings/pageBlocks'

import * as styles from './popularSearchesBlock.module.css'

interface IProps extends ICategoryPageBlockComponent {
  data: customerMarketShopfrontApi.categoryPage.PopularSearchesBlockData[]
}

const MAX_POPULAR_SEARCHES = 16

const PopularSearchesBlock = ({ data, title, locationParams }: IProps) => {
  return (
    <section className={styles.root}>
      <h2 className={styles.title}>{title}</h2>
      <PillsNav>
        {data
          .slice(0, MAX_POPULAR_SEARCHES)
          .map((term: string, index: number) => (
            <PillsNav.Pill
              key={index}
              locationParams={{ category: locationParams.category, term }}
              onClick={reportCategoryPageClick('popular search')}
            >
              {term}
            </PillsNav.Pill>
          ))}
      </PillsNav>
    </section>
  )
}

export default PopularSearchesBlock
